import w from '../assets/logo-white.png';
import b from '../assets/logo-black.png';
import rw from '../assets/mark-white.png';
import rb from '../assets/mark-black.png';

// w / b: full wordmark (white / black).  rw / rb: the R mark (white / black).
export const LOGO = { w, b, rw, rb };
